// OrderCountDisplay.js

import React from "react"
import { Typography, Popover, Descriptions } from "antd"
import { Link } from "react-router-dom" // Adjust based on your routing setup

const { Text } = Typography

const OrderCountDisplay = ({ value, record }) => {
  const { selectedProduct, rollCount, labelCount } = record

  if (selectedProduct.machine === "Tape") {
    return <Text copyable={{ text: rollCount.toString() }}>{rollCount} Rolls</Text>
  } else {
    const popoverContent = (
      <div style={{ padding: 5 }}>
        <Descriptions column={1} style={{ width: 150 }}>
          <Descriptions.Item label="Ordered">{labelCount}</Descriptions.Item>
          <Descriptions.Item label="Created">{value}</Descriptions.Item>
        </Descriptions>
      </div>
    )

    return (
      <Popover content={popoverContent} title="Amount details" trigger="click">
        <Link to="#">
          {" "}
          {/* Update the 'to' prop as needed */}
          {value}
        </Link>
      </Popover>
    )
  }
}

export default OrderCountDisplay
